import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const OutletAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.outletAccess
        ? setValues((j) => ({
            ...j,
            outlet: {
              create: true,
              edit: true,
              delete: true,
              register: true,
              registerCUD: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            outlet: {
              create: false,
              edit: false,
              delete: false,
              register: false,
              registerCUD: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.outletAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      outlet: { ...j.outlet, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.outletAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Create"
          checked={values.outlet?.create || false}
          name={"create"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Edit"
          checked={values.outlet?.edit || false}
          name={"edit"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Delete"
          checked={values.outlet?.delete || false}
          name={"delete"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Register"
          checked={values.outlet?.register || false}
          name={"register"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Register Create, Update, Delete"
          checked={values.outlet?.registerCUD || false}
          name={"registerCUD"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default OutletAccess;
